<div id="Mobile">
  <div class="sidebar-overlay" (click)="backdrop()"></div>
  <div class="sidebar-container animate__animated  animate__slideInLeft">
    <ng-container *ngTemplateOutlet="closeItem"></ng-container>

    <ng-container *ngTemplateOutlet="backItem"></ng-container>
    <ng-container *ngTemplateOutlet="listActions"></ng-container>
  </div>
</div>

<!-- main item close btn for close sidebar -->
<!-- static component  -->
<ng-template #closeItem>
  <div class="sidebar-container-mobile close-sidebar" (click)="closeSidebar()">
    <a class="item">
      <span class="fa fa-times"></span>
    </a>
  </div>
</ng-template>

<!-- back item for go back to the main section -->
<!-- static component  -->
<ng-template #backItem>
  @if (sidebarSrv.backEnabled | async) {
  <div class="sidebar-container-mobile actions animate__animated animate__fadeInLeft" (click)="goBack()">
    <a class="item">
      <span class="fa fa-arrow-left"></span>
    </a>
  </div>
  }
</ng-template>


<!-- list of the actions inside the sidebar -->
<ng-template #listActions>
  @for (action of sidebarSrv.actions | async; track $index) {
  <div>
    <div class="sidebar-container-mobile animate__animated animate__fadeInLeft" (click)="goTo(action.routerLink)">
      <a class="item">
        <span class="{{appStateHolder.iconClass(action.icon)}} {{action.icon}}"></span>
      </a>
    </div>
  </div>
  }
</ng-template>